import { forwardRef, type ComponentProps } from "react";
import { Input } from "@/shared/components/shadcn/Input";
import { bookingWebsiteOrigin } from "../utils/websiteUrl";

export const BookingLinkInput = forwardRef<HTMLInputElement, ComponentProps<"input">>(
  function BookingLinkInput(props, ref) {
    return (
      <div className="flex min-w-0 items-center overflow-hidden rounded-xl border border-border bg-card focus-within:ring-2 focus-within:ring-ring has-aria-invalid:border-destructive">
        <span className="shrink-0 pl-3 text-xs text-muted-foreground sm:text-sm">{new URL(bookingWebsiteOrigin).host}/book/</span>
        <Input {...props} ref={ref} className="min-w-0 flex-1 rounded-none border-0 px-1 font-semibold text-primary focus-visible:ring-0" />
      </div>
    );
  },
);
